import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxButton from '../components/Layout/BoxButton'
import ModalFilter from '../components/ExternosCotizaciones/ModalFilter'
import ModalSummary from '../components/ExternosCotizaciones/ModalSummary'


import ModalSummaryCotizaciones from '../components/ExternosCotizaciones/ModalSummaryCotizaciones'



import ModalDelete from '../components/Shared/ModalDelete'
import store from '../utils/store'
import  ModalAddFile from '../components/Shared/ModalAddFile'

import {
    getCotizaciones,
	filterCotizaciones,
	setOrderBy,
    changeRecordsToShow,
    showHideModalFilter,
    showHideModalSummary,
    showHideModalSummaryCotizaciones,
    addFile
} from '../actions/externoscotizaciones'


import history from '../utils/history'


import { 
    displayModalAddFile,
    getParameterByName
} from '../actions/common'




export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
	let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.cotizaciones.estados[value]
    }
	return value
}

class ExternosCotizaciones extends Component {
    
    componentWillMount() {
        this.props.getCotizaciones(1);
        this.props.getParameterByName('DIVISAS')
    }

	render() {

        const tableCols = [
            { id: 1, caption: 'Solicitud', value: 'solicitud_id', type: 'number', format: '', width: '10%' },
            { id: 2, caption: 'Proyecto/Evento/Actividad', value: 'proyecto_evento', type: 'string', format: '', width: '20%' },
            { id: 3, caption: 'Fecha límite cotización', value: 'fecha_cotizaciones', type: 'datetime', format: 'YYYY-MM-DD', width: '20%' },
            { id: 4, caption: 'Responsable compras', value: 'responsable_compras', type: 'string', format: '', width: '15%' },
            { id: 5, caption: 'Servicio', value: 'descripcion', type: 'string', format: '', width: '25%' },
            { id: 6, caption: 'Fecha entrega', value: 'fecha_requerido', type: 'datetime', format: 'YYYY-MM-DD', width: '10%' },
        ]

        const { cotizaciones, orderBy, page, totalRecords, showRecords, enums } = this.props

        const boxActions = [
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
        ]

        const pagination = <Pagination
            activePage={ page }
            itemsCountPerPage={ showRecords }
            totalItemsCount={ totalRecords }
            pageRangeDisplayed={ 10 }
            onChange={ (pg) => this.props.getCotizaciones(history.location.pathname, pg)  }
            firstPageText={ <FontAwesome name="angle-double-left" /> }
            prevPageText={ <FontAwesome name="angle-left" /> }
            nextPageText={ <FontAwesome name="angle-right" /> }
            lastPageText={ <FontAwesome name="angle-double-right" /> }
        />


		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Listado de cotizaciones pendientes" stretch>
                    
                        <ButtonStrip actions={ boxActions } />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-cotizaciones">
                                <thead>
                                    <tr>
                                        <th style={{ width: '23px' }}></th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cotizaciones.filter(x => x.get('visible')).count() > 0 ? cotizaciones.filter(x => x.get('visible')).map((x, n) => {
                                            return (
                                                <tr key={ `tr1[${x.get('solicitud_id')}-${n}]` } className={ x.get('selected') ? 'info' : '' }>

                                                    {
                                                        (x.get('id') != 0) ? (
                                                            <td style={{ padding: '0' }}><BoxButton size={ 12 } name="binoculars" onClick={ () => this.props.showHideModalSummary(true, x.get('id')) }/></td>
                                                        ):(
                                                            <td style={{ padding: '0' }}><BoxButton size={ 12 } name="binoculars" onClick={ () => this.props.showHideModalSummaryCotizaciones(true, x.get('solicitud_id')) }/></td>
                                                        )
                                                    }                                                   

                                                    
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = value ? moment(value).format(c.format) : null;
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => history.push(window.FOLDER + `/cotizaciones/${enums.cotizaciones.tipos[x.get('tipo')].url}/${x.get('id')}`) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>

                <ModalFilter />

                <ModalSummary displayModalAddFile={ this.props.displayModalAddFile } />

                <ModalSummaryCotizaciones displayModalAddFile={ this.props.displayModalAddFile } />

                <ModalAddFile
                    action={ () => this.props.addFile('modalSummary.data.adjunto') }
                />


                
                <ModalDelete />
                
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        cotizaciones: state.externoscotizaciones.get('cotizaciones'),
        orderBy: state.externoscotizaciones.get('orderBy'),
        totalRecords: state.externoscotizaciones.get('totalRecords'),
        showRecords: state.externoscotizaciones.get('showRecords'),
        page: state.externoscotizaciones.get('page'),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getCotizaciones: (page) => dispatch(getCotizaciones(page)),
		filterCotizaciones: (term) => dispatch(filterCotizaciones(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols)),
        showHideModalSummary: (show, index) => dispatch(showHideModalSummary(show, index)),
        showHideModalSummaryCotizaciones: (show, solicitud_id) => dispatch(showHideModalSummaryCotizaciones(show, solicitud_id)),
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)), 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternosCotizaciones)


// WEBPACK FOOTER //
// ./src/containers/ExternosCotizaciones.jsx